import styled from "styled-components";

export const StyledList = styled.ul`
  margin-bottom: 3rem;
`;
